import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VChip,{staticClass:"chip-style",attrs:{"large":""},on:{"click":_vm.ctaClick}},[_c('div',{staticClass:"d-flex align-center justify-center mx-3",staticStyle:{"width":"100% !important"}},[_c('h5',{staticClass:"powered-by-text"},[_vm._v(_vm._s(_vm.$t('poweredBy')))]),_c(VImg,{staticClass:"ml-1",attrs:{"src":_vm.imageUrl,"max-width":"70","position":"left center","contain":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }